import { createExternalApolloClient } from './apolloExternal';
import { createApolloClient } from './apolloInternal';

/**
 * For all views under the /external route we establish
 * a Graphql connection with Jwt token instead of internal
 * auth with the token
 */
let apolloClient = createApolloClient;
const path = window.location.pathname.substring(1).split('/');
if (path[0] === 'external') {
	apolloClient = createExternalApolloClient;
}

export { apolloClient as createApolloClient };

export { createApolloCache } from './apolloInternal';

export {
	usePersistedQueryLoading,
	APOLLO_PARAMS_PERSISTED_QUERY,
} from './apolloTools';
